/**
 * замена текста в кнопках при клике
 */
document.addEventListener('show.bs.collapse',(e) => {
    if(e.target && e.target.classList.contains('collapse')){
        const btns = document.querySelectorAll('[data-bs-toggle="collapse"][data-bs-target="#' + e.target.id + '"][data-bs-collapse-text-change="true"]');
        for (const btn of btns) {
            btn.innerHTML = btn.getAttribute('data-bs-collapse-text-expanded');
        }
    }
});
document.addEventListener('hide.bs.collapse',(e) => {
    if(e.target && e.target.classList.contains('collapse')){
        const btns = document.querySelectorAll('[data-bs-toggle="collapse"][data-bs-target="#' + e.target.id + '"][data-bs-collapse-text-change="true"]');
        for (const btn of btns) {
            btn.innerHTML = btn.getAttribute('data-bs-collapse-text-collapsed');
        }
    }
});
